<template>
  <v-app-bar app flat>
    <v-app-bar-nav-icon @click.stop="drawer()"></v-app-bar-nav-icon>
    <v-col>
      <v-img
        :src="require('@/assets/image/logo.svg')"
        contain
        height="30"
        position="top left"
      />
    </v-col>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "app-bar",
  components: {},

  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      drawerStatus: "navigationDrawer/GET_DRAWER"
    })
  },
  mounted() {},
  methods: {
    ...mapActions({
      drawerAction: "navigationDrawer/ACTION_DRAWER"
    }),
    drawer() {
      this.drawerAction(!this.drawerStatus);
    }
  }
};
</script>
<style scoped lang="scss">
@import "AppBar.scss";
</style>
